import React from 'react';

import { LS_KEYS } from '../hooks';
import useApi from './useApi';

const BASE_URL = '/report';

export const useReport = () => {
  const { get } = useApi(LS_KEYS.BACKOFFICE);

  /**
   * Orders Per Day (Chart)
   */
  const ordersPerDay = React.useCallback(
    async (begin, end) => {
      const orders = await get(
        `${BASE_URL}/orders-per-day?begin=${begin.getTime()}&end=${end.getTime()}`,
      );
      return orders;
    },
    [get],
  );

  /**
   * Most Ordered Menu item (Chart)
   */
  const mostOrderedMenuItem = React.useCallback(
    async (begin, end) => {
      const orders = await get(
        `${BASE_URL}/most-ordered-menu-item?begin=${begin.getTime()}&end=${end.getTime()}`,
      );
      return orders;
    },
    [get],
  );

  /**
   * Revenues Per Day (Chart)
   */
  const revenuesPerDay = React.useCallback(
    async (begin, end) => {
      const revenues = await get(
        `${BASE_URL}/revenues-per-day?begin=${begin.getTime()}&end=${end.getTime()}`,
      );
      return revenues;
    },
    [get],
  );

  /**
   * Top five ordered clients (Chart)
   */
  const topFiveOrderedClient = React.useCallback(
    async (begin, end) => {
      const orders = await get(
        `${BASE_URL}/top-five-ordered-clients?begin=${begin.getTime()}&end=${end.getTime()}`,
      );
      return orders;
    },
    [get],
  );

  /**
   * New Clients Per Day (Chart)
   */
  const newClientsPerDay = React.useCallback(
    async (begin, end) => {
      const clients = await get(
        `${BASE_URL}/new-clients-per-day?begin=${begin.getTime()}&end=${end.getTime()}`,
      );
      return clients;
    },
    [get],
  );

  return {
    ordersPerDay,
    mostOrderedMenuItem,
    revenuesPerDay,
    topFiveOrderedClient,
    newClientsPerDay,
  };
};

export default useReport;
